"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconTextCellRenderer = exports.textWrapId = void 0;
const react_1 = __importStar(require("react"));
const features_1 = require("../../Grid/features");
const Icon_1 = require("../../Icon");
const StackView_1 = require("../../StackView");
const Text_1 = require("../../Text");
exports.textWrapId = 'grid-text-wrap';
const IconTextCellRenderer = ({ cellData, columnWidth, rowData: { icon } }) => {
    const { state: { disabled } } = (0, features_1.useGridContext)();
    const style = (0, react_1.useMemo)(() => ({
        width: '100%',
        maxWidth: `${(columnWidth || 0) + 50}px`
    }), [columnWidth]);
    const view = (0, react_1.useMemo)(() => (disabled ? Text_1.TEXT_VIEW.light : Text_1.TEXT_VIEW.primary), [disabled]);
    if (cellData && columnWidth) {
        return (react_1.default.createElement(StackView_1.StackView, { gap: StackView_1.STACK_GAP.s, "data-selector-id": exports.textWrapId, style: style },
            icon && react_1.default.createElement(Icon_1.Icon, { disabled: disabled, src: icon }),
            react_1.default.createElement(Text_1.Text, { view: view, truncate: true }, cellData)));
    }
    return null;
};
exports.IconTextCellRenderer = IconTextCellRenderer;
//# sourceMappingURL=iconTextCellRenderer.js.map